import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import './Asesoramiento.css';

const Asesoramiento = () => {
    return (
        <div className="asesoramiento-container">
                {/* Agregar el Header */}
                <Header 
                userRole={null}
                username={null} 
                handleLogout={() => {}} 
                setModalOpen={() => {}} 
                setRegisterModalOpen={() => {}} 
            />
            {/* Sección Hero */}
            <div className="hero-section" style={{ backgroundImage: 'linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(../images/5.jpg)' }}>
                <div className="hero-content">
                    <h1>¡Descubre la emoción de los eventos deportivos con nosotros!</h1>
                    <p>Experiencias únicas para los amantes del deporte</p>
                </div>
            </div>

            {/* Contenido Principal */}
            <div className="content-wrapper">
                {/* Sección de Introducción */}
                <section className="intro-section">
                    <div className="intro-text">
                        <h2>En INNOVATE SPORT</h2>
                        <p>
                            Nos apasiona crear experiencias únicas y emocionantes para los amantes del deporte. 
                            Nuestro equipo de expertos en eventos deportivos se dedica a diseñar, planificar 
                            y ejecutar eventos de bici montaña y running que superan las expectativas de nuestros clientes.
                        </p>
                    </div>
                    <div className="intro-image">
                        <img src="../images/1.jpeg" alt="Equipo de deportes" />
                    </div>
                </section>

                {/* Sección de Asesoramiento */}
                <section className="services-section">
                    <div className="service-card">
                        <div className="service-icon">
                            <img src="../images/logox.png" alt="Icono asesoramiento" />
                        </div>
                        <h3>Asesoramiento</h3>
                        <p>
                            Nuestro equipo de expertos en eventos deportivos está disponible para asesorarte en todo momento. 
                            Desde la conceptualización inicial hasta la ejecución final, nos aseguramos de que cada detalle 
                            esté cuidadosamente planificado para garantizar el éxito de tu evento.
                        </p>
                    </div>
                </section>

                {/* Sección de Ejecución */}
                <section className="execution-section">
                    <h2>Ejecución Profesional</h2>
                    <div className="execution-content">
                        <div className="execution-image">
                            <img src="../images/2.jpg" alt="Ejecución de eventos" />
                        </div>
                        <div className="execution-list">
                            <p>Nuestra experiencia nos permite ofrecer:</p>
                            <ul>
                                <li>Diseño y planificación de rutas y circuitos</li>
                                <li>Coordinación de logística y transporte</li>
                                <li>Gestión de seguridad y emergencias</li>
                                <li>Diseño de materiales de marketing</li>
                                <li>Coordinación de actividades y entretenimiento</li>
                            </ul>
                        </div>
                    </div>
                </section>

                {/* Sección de Eventos Personalizados */}
                <section className="custom-events">
                    <div className="custom-content">
                        <h2>Eventos Personalizados</h2>
                        <p>
                            Nos enfocamos en crear eventos que se adapten a tus necesidades específicas. 
                            Ya sea un evento corporativo, una carrera benéfica o una aventura con amigos, 
                            garantizamos una experiencia inolvidable.
                        </p>
                        <div className="event-types">
                            <div className="event-type">
                                <img src="../images/1.jpeg" alt="Eventos corporativos" />
                                <h4>Eventos Corporativos</h4>
                            </div>
                            <div className="event-type">
                                <img src="../images/2.jpg" alt="Carreras benéficas" />
                                <h4>Carreras Benéficas</h4>
                            </div>
                            <div className="event-type">
                                <img src="../images/3.jpg" alt="Aventuras deportivas" />
                                <h4>Aventuras Deportivas</h4>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Sección de Contacto */}
                <section className="contact-section">
                    <div className="contact-content">
                        <h2>¿Listo para crear una experiencia inolvidable?</h2>
                        <p>Contáctanos hoy mismo para obtener más información sobre nuestros servicios</p>
                        <Link to="/contacto" className="cta-button">Contáctanos</Link>
                    </div>
                    <div className="contact-image">
                        <img src="../images/4.jpg" alt="Contacto deportivo" />
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Asesoramiento;